export default __webpack_public_path__ + "static/cp-components-981bedfc9ef3616862f52a25c3dcc42f.jpg";